module.exports = __webpack_public_path__ + "static/media/certificadoIBMModeladoDeSistemasConRational.29da8487.png";